// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nfc-chat-page {
    width: 100vw;
    height: 100vh;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    color: #EAE0C8;
    font-family: 'Urbanist-Regular', sans-serif;
}

@supports (height: 100dvh) {
    .nfc-chat-page {
        height: 100dvh;
    }
}

.nfc-chat-background-layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: -webkit-fill-available;
    z-index: -2;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    pointer-events: none;
}

.coin-button {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
}

.user-button {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    display: flex;

}

.nfc-chat-page::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1;
}

.nfc-chat-header {
    width: 100%;
    padding: 20px;
    padding-top: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    z-index: 10;
}

.back-button {
    background: none;
    border: none;
    color: rgba(213, 190, 155, 1);
    cursor: pointer;
    padding: 0;
    margin-right: 10px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.back-button:hover {
    color: rgba(213, 190, 155, 0.7);
    transform: translateX(-2px);
}

.back-button svg {
    width: 24px;
    height: 24px;
}

.header-right {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.nfc-pill {
    background: rgba(213, 190, 155, 0.24);
    border: none;
    border-radius: 30px;
    padding: 0.6rem 1.5rem;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: rgba(213, 190, 155, 1);
    backdrop-filter: blur(5px);
    cursor: pointer;
    transition: all 0.2s;
    font-family: 'Urbanist-Regular', sans-serif;
    letter-spacing: 0.08em;
    isolation: isolate;
    position: relative;
}

.nfc-pill::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 30px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    z-index: -1;
}

.nfc-pill:hover {
    background: rgba(213, 190, 155, 0.35);
    transform: translateY(-1px);
}

.nfc-pill.user-logged-in {
    padding: 0.6rem;
    cursor: pointer;
}

.nfc-pill.user-logged-in:hover {
    background: rgba(213, 190, 155, 0.24);
    transform: none;
}

.nfc-pill img {
    width: 16px;
    height: 16px;
}


.nfc-chat-content {
    flex: 1 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    padding-bottom: 180px;

    box-sizing: border-box;
    overflow-y: auto;
    z-index: 5;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.nfc-chat-content::-webkit-scrollbar {
    display: none;
}

.nfc-chat-content.expanded {
    padding-bottom: 20px;
}

.card-display-area {
    width: 100%;
    max-width: 340px;
    background: rgba(0, 0, 0, 0.4);

    border-radius: 20px;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
    /* Prevent shrinking when not expanded */
    height: auto;
    min-height: 250px;
}

.card-display-area img {
    width: 140px;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    transition: width 0.4s ease;
}

@media (max-width: 480px) {
    .card-display-area img {
        width: 110px;
    }

    .nfc-chat-header {
        padding: 15px;
        padding-top: 30px;
    }

    .nfc-pill {
        padding: 0.4rem 0.8rem;
        font-size: 12px;
        gap: 5px;
    }

    .nfc-pill img {
        width: 14px;
        height: 14px;
    }

    .header-right {
        gap: 6px;
    }
}

.card-display-area.expanded {
    width: 100%;
    max-width: 100%;
    height: 100%;
    z-index: 20;
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: none;
    border-radius: 50px;
    padding: 40px 20px;
    margin: 0;
    overflow-y: auto;
    justify-content: flex-start;
    flex: 1 1;
    /* Hide scrollbar */
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.card-display-area.expanded::-webkit-scrollbar {
    display: none;
}

.card-display-area img.reversed {
    transform: rotate(180deg);
}

.card-label {
    margin-top: 15px;
    font-size: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #EAE0C8;
    /* Default fallback */
}

.card-label.upright {
    color: #AFC6FF;
    text-shadow: 0 0 10px rgba(175, 198, 255, 0.5);
}

.card-label.reversed {
    color: #FFB48A;
    text-shadow: 0 0 10px rgba(255, 180, 138, 0.5);
}

.chat-bubble {
    background: rgba(20, 20, 20, 0.8);
    border: 1px solid rgba(234, 224, 200, 0.2);
    border-radius: 20px;
    padding: 20px;
    width: 100%;
    max-width: 340px;
    box-sizing: border-box;
    margin-bottom: 20px;
    backdrop-filter: blur(10px);
}

.chat-text {
    font-family: 'Urbanist-Regular', sans-serif;
    /* More readable font for text */
    font-size: 14px;
    line-height: 1.6;
    color: #EAE0C8;
    margin: 0;
}

.chat-footer {
    position: absolute;
    bottom: 30px;
    text-align: center;
    width: 100%;
    font-size: 12px;
    opacity: 0.6;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.card-display-area img.upright-glow {
    box-shadow: 0 0 30px rgba(0, 123, 255, 0.4);
}

.card-display-area img.reversed-glow {
    box-shadow: 0 0 30px rgba(255, 165, 0, 0.4);
}

.card-display-area.expanded img {
    width: 180px;
    margin-bottom: 20px;
}

@media (max-width: 480px) {
    .card-display-area.expanded img {
        width: 150px;
    }
}

.card-details {
    text-align: center;
    max-width: 600px;
    animation: fadeIn 0.5s ease;
}

.card-title {
    font-size: 24px;
    color: #EAE0C8;
    margin-bottom: 5px;
    text-transform: uppercase;
}

.card-subtitle {
    font-size: 14px;
    color: #888;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: bold;
}

.card-subtitle.upright {
    color: #AFC6FF;
}

.card-subtitle.reversed {
    color: #FFB48A;
}

.card-meaning-text {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 14px;
    line-height: 1.8;
    color: #ccc;
    margin-bottom: 16px;
    text-align: left;
}

.card-meaning-text p {
    margin: 0;
}

.card-general-meaning {
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 13px;
    line-height: 1.6;
    color: #D5BE9B;
    margin-bottom: 16px;
    text-align: left;
    padding: 12px;
    background: rgba(213, 190, 155, 0.1);
    border-radius: 8px;
    border-left: 3px solid #D5BE9B;
}

.card-general-meaning p {
    margin: 0;
}

.card-keywords {
    text-align: left;
    margin-top: 20px;
}

.card-keywords h4 {
    color: #d4af37;
    margin-bottom: 10px;
    font-size: 14px;
    text-transform: uppercase;
}

.card-keywords ul {
    list-style-type: disc;
    padding-left: 20px;
    color: #ccc;
}

.card-keywords li {
    margin-bottom: 5px;
}

.close-expanded-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    color: #EAE0C8;
    font-size: 30px;
    cursor: pointer;
}

/* Selection Buttons */
.selection-area {
    width: 100%;
    max-width: 340px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
}

.selection-btn {
    background: rgba(20, 20, 20, 0.8);
    border: 1px solid rgba(234, 224, 200, 0.3);
    border-radius: 15px;
    padding: 20px;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.selection-btn:hover {
    background: rgba(40, 40, 40, 0.9);
    border-color: #d4af37;
}

.btn-content h3 {
    margin: 0 0 5px 0;
    color: #EAE0C8;
    font-size: 16px;
}

.btn-content p {
    margin: 0;
    color: #888;
    font-size: 12px;
}

.btn-arrow {
    color: #d4af37;
    font-size: 20px;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Chat Input Area */
.chat-input-container {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 95%;
    max-width: 500px;
    background: rgba(0, 0, 0, 0.95);
    border: 1px solid rgba(100, 100, 100, 0.3);
    border-radius: 30px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    z-index: 30;
    backdrop-filter: blur(10px);
}

.input-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.chat-input {
    flex: 1 1;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.9);
    padding: 0;
    font-size: 16px;
    outline: none;
    font-family: 'Urbanist-Regular', sans-serif;
}

.chat-input::placeholder {
    color: rgba(150, 150, 150, 0.5);
}

.refresh-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: rgba(200, 180, 140, 0.8);
    transition: all 0.2s;
    flex-shrink: 0;
}

.refresh-btn:hover {
    color: rgba(200, 180, 140, 1);
    transform: rotate(90deg);
}

.refresh-btn svg {
    width: 20px;
    height: 20px;
}

.controls-row {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: space-between;
}

.reading-type-toggle {
    background: rgba(100, 80, 60, 0.5);
    border: 1px solid rgba(150, 130, 100, 0.3);
    border-radius: 25px;
    padding: 10px 16px;
    color: rgba(200, 180, 140, 1);
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
    font-family: 'Urbanist-Regular', sans-serif;
    white-space: nowrap;
}

.reading-type-toggle:hover {
    background: rgba(100, 80, 60, 0.7);
}

.reading-type-toggle img {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
}

.reading-type-toggle.fast {
    background: rgba(36, 32, 27, 1);
}

.reading-type-toggle.fast:hover {
    background: rgba(46, 42, 37, 1);
}

.right-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.coin-display {
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(200, 180, 140, 1);
    font-size: 16px;
    font-weight: 500;
    flex-shrink: 0;
}

.coin-display img {
    width: 20px;
    height: 20px;
}

.send-btn {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgba(100, 80, 60, 0.5);
    border: 1px solid rgba(150, 130, 100, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.send-btn:hover {
    background: rgba(100, 80, 60, 0.7);
    transform: scale(1.05);
}

.send-btn:active {
    transform: scale(0.95);
}

.send-btn svg {
    width: 22px;
    height: 22px;
    fill: rgba(200, 180, 140, 1);
}

/* Chat Messages */
.chat-messages-area {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
}

.message {
    padding: 15px;
    border-radius: 15px;
    font-size: 14px;
    line-height: 1.5;
    max-width: 85%;
    animation: fadeIn 0.3s ease;
    font-family: 'Urbanist-Regular', sans-serif;
    text-transform: none;
}

.message.user {
    align-self: flex-end;
    background: rgba(212, 175, 55, 0.2);
    border: 1px solid rgba(212, 175, 55, 0.3);
    color: #EAE0C8;
    border-bottom-right-radius: 2px;
}

.message.ai {
    align-self: flex-start;
    background: rgba(20, 20, 20, 0.8);
    border: 1px solid rgba(234, 224, 200, 0.2);
    color: #EAE0C8;
    border-bottom-left-radius: 2px;
}

/* Markdown styling within messages */
.message p {
    margin: 0 0 10px 0;
    text-transform: none;
}

.message p:last-child {
    margin-bottom: 0;
}

.message strong {
    font-weight: 600;
    color: #d4af37;
    text-transform: none;
}

.message em {
    font-style: italic;
    color: rgba(234, 224, 200, 0.9);
    text-transform: none;
}

.message ul,
.message ol {
    margin: 10px 0;
    padding-left: 20px;
}

.message li {
    margin: 5px 0;
    text-transform: none;
}

.message code {
    background: rgba(0, 0, 0, 0.3);
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Urbanist-Regular', sans-serif;
    font-size: 13px;
}

.message pre {
    background: rgba(0, 0, 0, 0.3);
    padding: 10px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 10px 0;
}

.message pre code {
    background: none;
    padding: 0;
}

.loading-dots {
    display: flex;
    gap: 4px;
}

.loading-dots span {
    width: 6px;
    height: 6px;
    background: #d4af37;
    border-radius: 50%;
    animation: bounce 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
    animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes bounce {

    0%,
    80%,
    100% {
        transform: scale(0);
    }

    40% {
        transform: scale(1);
    }
}

/* Language Selection Modal */
.language-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    backdrop-filter: blur(10px);
}

.language-modal-content {
    background: rgba(30, 25, 20, 0.95);
    border: 1px solid rgba(212, 175, 55, 0.3);
    border-radius: 20px;
    padding: 40px;
    text-align: center;
    max-width: 350px;
    width: 90%;
    animation: fadeIn 0.3s ease;
    font-family: 'Urbanist-Regular'
}

.language-modal-content h2 {
    color: #EAE0C8;
    font-size: 20px;
    margin-bottom: 30px;
    font-weight: 400;
}

.language-options {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.language-options button {
    background: rgba(212, 175, 55, 0.15);
    border: 1px solid rgba(212, 175, 55, 0.4);
    border-radius: 12px;
    padding: 16px 24px;
    color: #EAE0C8;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: 'Urbanist-Regular', sans-serif;
}

.language-options button:hover {
    background: rgba(212, 175, 55, 0.3);
    border-color: rgba(212, 175, 55, 0.6);
    transform: translateY(-2px);
}`, "",{"version":3,"sources":["webpack://./src/nfc/NfcChat.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,oBAAoB;IACpB,2CAA2C;IAC3C,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,SAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;;IAErB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,8BAA8B;;IAE9B,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;IACjD,cAAc;IACd,wCAAwC;IACxC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,2BAA2B;IAC3B,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,SAAO;IACP,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,2CAA2C;IAC3C,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,YAAY;IACZ,+BAA+B;IAC/B,UAAU;IACV,eAAe;IACf,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,+BAA+B;IAC/B,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,0CAA0C;IAC1C,cAAc;IACd,8BAA8B;AAClC;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gDAAgD;AACpD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI;;;QAGI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;IAC3B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,2BAA2B;AAC/B","sourcesContent":[".nfc-chat-page {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: transparent;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n    color: #EAE0C8;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n}\r\n\r\n@supports (height: 100dvh) {\r\n    .nfc-chat-page {\r\n        height: 100dvh;\r\n    }\r\n}\r\n\r\n.nfc-chat-background-layer {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    height: -webkit-fill-available;\r\n    z-index: -2;\r\n    background-size: 100% 100%;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    pointer-events: none;\r\n}\r\n\r\n.coin-button {\r\n    background: transparent;\r\n    border: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.user-button {\r\n    background: transparent;\r\n    border: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    cursor: pointer;\r\n    display: flex;\r\n\r\n}\r\n\r\n.nfc-chat-page::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    z-index: 1;\r\n}\r\n\r\n.nfc-chat-header {\r\n    width: 100%;\r\n    padding: 20px;\r\n    padding-top: 40px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    box-sizing: border-box;\r\n    z-index: 10;\r\n}\r\n\r\n.back-button {\r\n    background: none;\r\n    border: none;\r\n    color: rgba(213, 190, 155, 1);\r\n    cursor: pointer;\r\n    padding: 0;\r\n    margin-right: 10px;\r\n    width: 24px;\r\n    height: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.back-button:hover {\r\n    color: rgba(213, 190, 155, 0.7);\r\n    transform: translateX(-2px);\r\n}\r\n\r\n.back-button svg {\r\n    width: 24px;\r\n    height: 24px;\r\n}\r\n\r\n.header-right {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 10px;\r\n}\r\n\r\n.nfc-pill {\r\n    background: rgba(213, 190, 155, 0.24);\r\n    border: none;\r\n    border-radius: 30px;\r\n    padding: 0.6rem 1.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 14px;\r\n    color: rgba(213, 190, 155, 1);\r\n    backdrop-filter: blur(5px);\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    letter-spacing: 0.08em;\r\n    isolation: isolate;\r\n    position: relative;\r\n}\r\n\r\n.nfc-pill::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 30px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n    z-index: -1;\r\n}\r\n\r\n.nfc-pill:hover {\r\n    background: rgba(213, 190, 155, 0.35);\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.nfc-pill.user-logged-in {\r\n    padding: 0.6rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.nfc-pill.user-logged-in:hover {\r\n    background: rgba(213, 190, 155, 0.24);\r\n    transform: none;\r\n}\r\n\r\n.nfc-pill img {\r\n    width: 16px;\r\n    height: 16px;\r\n}\r\n\r\n\r\n.nfc-chat-content {\r\n    flex: 1;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 20px;\r\n    padding-bottom: 180px;\r\n\r\n    box-sizing: border-box;\r\n    overflow-y: auto;\r\n    z-index: 5;\r\n    -ms-overflow-style: none;\r\n    scrollbar-width: none;\r\n}\r\n\r\n.nfc-chat-content::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.nfc-chat-content.expanded {\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.card-display-area {\r\n    width: 100%;\r\n    max-width: 340px;\r\n    background: rgba(0, 0, 0, 0.4);\r\n\r\n    border-radius: 20px;\r\n    padding: 30px 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n    position: relative;\r\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n    flex-shrink: 0;\r\n    /* Prevent shrinking when not expanded */\r\n    height: auto;\r\n    min-height: 250px;\r\n}\r\n\r\n.card-display-area img {\r\n    width: 140px;\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\r\n    transition: width 0.4s ease;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .card-display-area img {\r\n        width: 110px;\r\n    }\r\n\r\n    .nfc-chat-header {\r\n        padding: 15px;\r\n        padding-top: 30px;\r\n    }\r\n\r\n    .nfc-pill {\r\n        padding: 0.4rem 0.8rem;\r\n        font-size: 12px;\r\n        gap: 5px;\r\n    }\r\n\r\n    .nfc-pill img {\r\n        width: 14px;\r\n        height: 14px;\r\n    }\r\n\r\n    .header-right {\r\n        gap: 6px;\r\n    }\r\n}\r\n\r\n.card-display-area.expanded {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    height: 100%;\r\n    z-index: 20;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border: none;\r\n    border-radius: 50px;\r\n    padding: 40px 20px;\r\n    margin: 0;\r\n    overflow-y: auto;\r\n    justify-content: flex-start;\r\n    flex: 1;\r\n    /* Hide scrollbar */\r\n    -ms-overflow-style: none;\r\n    scrollbar-width: none;\r\n}\r\n\r\n.card-display-area.expanded::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n.card-display-area img.reversed {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.card-label {\r\n    margin-top: 15px;\r\n    font-size: 14px;\r\n    letter-spacing: 2px;\r\n    text-transform: uppercase;\r\n    color: #EAE0C8;\r\n    /* Default fallback */\r\n}\r\n\r\n.card-label.upright {\r\n    color: #AFC6FF;\r\n    text-shadow: 0 0 10px rgba(175, 198, 255, 0.5);\r\n}\r\n\r\n.card-label.reversed {\r\n    color: #FFB48A;\r\n    text-shadow: 0 0 10px rgba(255, 180, 138, 0.5);\r\n}\r\n\r\n.chat-bubble {\r\n    background: rgba(20, 20, 20, 0.8);\r\n    border: 1px solid rgba(234, 224, 200, 0.2);\r\n    border-radius: 20px;\r\n    padding: 20px;\r\n    width: 100%;\r\n    max-width: 340px;\r\n    box-sizing: border-box;\r\n    margin-bottom: 20px;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.chat-text {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    /* More readable font for text */\r\n    font-size: 14px;\r\n    line-height: 1.6;\r\n    color: #EAE0C8;\r\n    margin: 0;\r\n}\r\n\r\n.chat-footer {\r\n    position: absolute;\r\n    bottom: 30px;\r\n    text-align: center;\r\n    width: 100%;\r\n    font-size: 12px;\r\n    opacity: 0.6;\r\n    letter-spacing: 1px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.card-display-area img.upright-glow {\r\n    box-shadow: 0 0 30px rgba(0, 123, 255, 0.4);\r\n}\r\n\r\n.card-display-area img.reversed-glow {\r\n    box-shadow: 0 0 30px rgba(255, 165, 0, 0.4);\r\n}\r\n\r\n.card-display-area.expanded img {\r\n    width: 180px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .card-display-area.expanded img {\r\n        width: 150px;\r\n    }\r\n}\r\n\r\n.card-details {\r\n    text-align: center;\r\n    max-width: 600px;\r\n    animation: fadeIn 0.5s ease;\r\n}\r\n\r\n.card-title {\r\n    font-size: 24px;\r\n    color: #EAE0C8;\r\n    margin-bottom: 5px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.card-subtitle {\r\n    font-size: 14px;\r\n    color: #888;\r\n    margin-bottom: 20px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    font-weight: bold;\r\n}\r\n\r\n.card-subtitle.upright {\r\n    color: #AFC6FF;\r\n}\r\n\r\n.card-subtitle.reversed {\r\n    color: #FFB48A;\r\n}\r\n\r\n.card-meaning-text {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 14px;\r\n    line-height: 1.8;\r\n    color: #ccc;\r\n    margin-bottom: 16px;\r\n    text-align: left;\r\n}\r\n\r\n.card-meaning-text p {\r\n    margin: 0;\r\n}\r\n\r\n.card-general-meaning {\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 13px;\r\n    line-height: 1.6;\r\n    color: #D5BE9B;\r\n    margin-bottom: 16px;\r\n    text-align: left;\r\n    padding: 12px;\r\n    background: rgba(213, 190, 155, 0.1);\r\n    border-radius: 8px;\r\n    border-left: 3px solid #D5BE9B;\r\n}\r\n\r\n.card-general-meaning p {\r\n    margin: 0;\r\n}\r\n\r\n.card-keywords {\r\n    text-align: left;\r\n    margin-top: 20px;\r\n}\r\n\r\n.card-keywords h4 {\r\n    color: #d4af37;\r\n    margin-bottom: 10px;\r\n    font-size: 14px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.card-keywords ul {\r\n    list-style-type: disc;\r\n    padding-left: 20px;\r\n    color: #ccc;\r\n}\r\n\r\n.card-keywords li {\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.close-expanded-btn {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    background: none;\r\n    border: none;\r\n    color: #EAE0C8;\r\n    font-size: 30px;\r\n    cursor: pointer;\r\n}\r\n\r\n/* Selection Buttons */\r\n.selection-area {\r\n    width: 100%;\r\n    max-width: 340px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.selection-btn {\r\n    background: rgba(20, 20, 20, 0.8);\r\n    border: 1px solid rgba(234, 224, 200, 0.3);\r\n    border-radius: 15px;\r\n    padding: 20px;\r\n    text-align: left;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.selection-btn:hover {\r\n    background: rgba(40, 40, 40, 0.9);\r\n    border-color: #d4af37;\r\n}\r\n\r\n.btn-content h3 {\r\n    margin: 0 0 5px 0;\r\n    color: #EAE0C8;\r\n    font-size: 16px;\r\n}\r\n\r\n.btn-content p {\r\n    margin: 0;\r\n    color: #888;\r\n    font-size: 12px;\r\n}\r\n\r\n.btn-arrow {\r\n    color: #d4af37;\r\n    font-size: 20px;\r\n}\r\n\r\n@keyframes fadeIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(20px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n/* Chat Input Area */\r\n.chat-input-container {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 95%;\r\n    max-width: 500px;\r\n    background: rgba(0, 0, 0, 0.95);\r\n    border: 1px solid rgba(100, 100, 100, 0.3);\r\n    border-radius: 30px;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    z-index: 30;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.input-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.chat-input {\r\n    flex: 1;\r\n    background: transparent;\r\n    border: none;\r\n    color: rgba(255, 255, 255, 0.9);\r\n    padding: 0;\r\n    font-size: 16px;\r\n    outline: none;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n}\r\n\r\n.chat-input::placeholder {\r\n    color: rgba(150, 150, 150, 0.5);\r\n}\r\n\r\n.refresh-btn {\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    background: transparent;\r\n    border: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    color: rgba(200, 180, 140, 0.8);\r\n    transition: all 0.2s;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.refresh-btn:hover {\r\n    color: rgba(200, 180, 140, 1);\r\n    transform: rotate(90deg);\r\n}\r\n\r\n.refresh-btn svg {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n.controls-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    justify-content: space-between;\r\n}\r\n\r\n.reading-type-toggle {\r\n    background: rgba(100, 80, 60, 0.5);\r\n    border: 1px solid rgba(150, 130, 100, 0.3);\r\n    border-radius: 25px;\r\n    padding: 10px 16px;\r\n    color: rgba(200, 180, 140, 1);\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    transition: all 0.2s;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    white-space: nowrap;\r\n}\r\n\r\n.reading-type-toggle:hover {\r\n    background: rgba(100, 80, 60, 0.7);\r\n}\r\n\r\n.reading-type-toggle img {\r\n    width: 18px;\r\n    height: 18px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.reading-type-toggle.fast {\r\n    background: rgba(36, 32, 27, 1);\r\n}\r\n\r\n.reading-type-toggle.fast:hover {\r\n    background: rgba(46, 42, 37, 1);\r\n}\r\n\r\n.right-controls {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.coin-display {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    color: rgba(200, 180, 140, 1);\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.coin-display img {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n.send-btn {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    background: rgba(100, 80, 60, 0.5);\r\n    border: 1px solid rgba(150, 130, 100, 0.3);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.send-btn:hover {\r\n    background: rgba(100, 80, 60, 0.7);\r\n    transform: scale(1.05);\r\n}\r\n\r\n.send-btn:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.send-btn svg {\r\n    width: 22px;\r\n    height: 22px;\r\n    fill: rgba(200, 180, 140, 1);\r\n}\r\n\r\n/* Chat Messages */\r\n.chat-messages-area {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    width: 100%;\r\n}\r\n\r\n.message {\r\n    padding: 15px;\r\n    border-radius: 15px;\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n    max-width: 85%;\r\n    animation: fadeIn 0.3s ease;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    text-transform: none;\r\n}\r\n\r\n.message.user {\r\n    align-self: flex-end;\r\n    background: rgba(212, 175, 55, 0.2);\r\n    border: 1px solid rgba(212, 175, 55, 0.3);\r\n    color: #EAE0C8;\r\n    border-bottom-right-radius: 2px;\r\n}\r\n\r\n.message.ai {\r\n    align-self: flex-start;\r\n    background: rgba(20, 20, 20, 0.8);\r\n    border: 1px solid rgba(234, 224, 200, 0.2);\r\n    color: #EAE0C8;\r\n    border-bottom-left-radius: 2px;\r\n}\r\n\r\n/* Markdown styling within messages */\r\n.message p {\r\n    margin: 0 0 10px 0;\r\n    text-transform: none;\r\n}\r\n\r\n.message p:last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.message strong {\r\n    font-weight: 600;\r\n    color: #d4af37;\r\n    text-transform: none;\r\n}\r\n\r\n.message em {\r\n    font-style: italic;\r\n    color: rgba(234, 224, 200, 0.9);\r\n    text-transform: none;\r\n}\r\n\r\n.message ul,\r\n.message ol {\r\n    margin: 10px 0;\r\n    padding-left: 20px;\r\n}\r\n\r\n.message li {\r\n    margin: 5px 0;\r\n    text-transform: none;\r\n}\r\n\r\n.message code {\r\n    background: rgba(0, 0, 0, 0.3);\r\n    padding: 2px 6px;\r\n    border-radius: 4px;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n    font-size: 13px;\r\n}\r\n\r\n.message pre {\r\n    background: rgba(0, 0, 0, 0.3);\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    overflow-x: auto;\r\n    margin: 10px 0;\r\n}\r\n\r\n.message pre code {\r\n    background: none;\r\n    padding: 0;\r\n}\r\n\r\n.loading-dots {\r\n    display: flex;\r\n    gap: 4px;\r\n}\r\n\r\n.loading-dots span {\r\n    width: 6px;\r\n    height: 6px;\r\n    background: #d4af37;\r\n    border-radius: 50%;\r\n    animation: bounce 1.4s infinite ease-in-out both;\r\n}\r\n\r\n.loading-dots span:nth-child(1) {\r\n    animation-delay: -0.32s;\r\n}\r\n\r\n.loading-dots span:nth-child(2) {\r\n    animation-delay: -0.16s;\r\n}\r\n\r\n@keyframes bounce {\r\n\r\n    0%,\r\n    80%,\r\n    100% {\r\n        transform: scale(0);\r\n    }\r\n\r\n    40% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n/* Language Selection Modal */\r\n.language-modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.85);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 100;\r\n    backdrop-filter: blur(10px);\r\n}\r\n\r\n.language-modal-content {\r\n    background: rgba(30, 25, 20, 0.95);\r\n    border: 1px solid rgba(212, 175, 55, 0.3);\r\n    border-radius: 20px;\r\n    padding: 40px;\r\n    text-align: center;\r\n    max-width: 350px;\r\n    width: 90%;\r\n    animation: fadeIn 0.3s ease;\r\n    font-family: 'Urbanist-Regular'\r\n}\r\n\r\n.language-modal-content h2 {\r\n    color: #EAE0C8;\r\n    font-size: 20px;\r\n    margin-bottom: 30px;\r\n    font-weight: 400;\r\n}\r\n\r\n.language-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n}\r\n\r\n.language-options button {\r\n    background: rgba(212, 175, 55, 0.15);\r\n    border: 1px solid rgba(212, 175, 55, 0.4);\r\n    border-radius: 12px;\r\n    padding: 16px 24px;\r\n    color: #EAE0C8;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n    font-family: 'Urbanist-Regular', sans-serif;\r\n}\r\n\r\n.language-options button:hover {\r\n    background: rgba(212, 175, 55, 0.3);\r\n    border-color: rgba(212, 175, 55, 0.6);\r\n    transform: translateY(-2px);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
